<div style="text-align: center; margin-bottom: 25px;">
    <h1 style="display: inline; position: relative; left: 100px;">
        @if (type === RequestResultsType.Approver) {
        My Approval Requests
        }
        @else {
        My Requests
        }
    </h1>
    <div style="float: right;display: flex;position: relative;right: 5px;">
        <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic"
            matTooltip="filter by creation date">
            <mat-label>request filter</mat-label>
            <mat-select [disabled]="isSearching" [value]="filterRequestAge"
                (selectionChange)="onFilterRequestAgeChange($event)">
                @for (option of filterRequestAgeOptions; track option.value) {
                <mat-option [value]="option.value">{{option.displayName}}</mat-option>
                }
            </mat-select>
        </mat-form-field>
    </div>
</div>
@if (isSearching) {
<div class="container">
    <div class="row justify-content-center col-sm-12">
        <p>Loading requests...</p>
    </div>
    <div class="row justify-content-center col-sm-12">
        <mat-spinner></mat-spinner>
    </div>
</div>
}
@else {
<app-workflow-request-display [requests]="searchResults" [includeFilter]="true" [includePaginator]="true"
    [showRequestorPicker]="hasAdminRole" [selectedRequestor]="selectedUser"
    (requestorSelectionChanged)="selectedRequestorChanged($event)"></app-workflow-request-display>
}

@if (screenMessage !== '') {
<div class="container">
    <p class="text-danger text-center">{{screenMessage}}</p>
</div>
}